var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("i", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "loading",
    }),
    _vm._v(" "),
    _vm.result && _vm.result.status == "OK"
      ? _c("div", [_vm._v("OK")])
      : _vm._e(),
    _vm._v(" "),
    _vm.result && _vm.result.status == "KO"
      ? _c("div", { staticClass: "text-danger" }, [
          _vm._v(_vm._s(_vm.result.msg)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }